import CustomerSchedulingCalendar from './CustomerSchedulingCalendar';

export default CustomerSchedulingCalendar;
